<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind(shopSoort.Catalogus)">
  <app-catalog-groups-boxed-layout *ngSwitchDefault [ctx]="ctx"></app-catalog-groups-boxed-layout>
  <app-catalog-groups-scroll-layout *ngSwitchCase="1" [ctx]="ctx"></app-catalog-groups-scroll-layout>
</ng-container>
